import { reducerWithInitialState } from "typescript-fsa-reducers";
import {
  appendTagArea,
  disableTagMode,
  editTagAreaText,
  enableTagMode,
  saveTagArea,
  setActiveTagArea,
  setTagConfig
} from "./actions";

import { TagArea, TagCompleteState, TagConfig, TagInitialState } from "./types";

const initialState = {
  areas: [],
  tagMode: false,
  config: {} as TagConfig
};

export type TagState = TagInitialState | TagCompleteState;

export default reducerWithInitialState<Readonly<TagState>>(initialState)
  .case(setActiveTagArea, (state, areaId) => {
    const config = state.config;
    const newConfig = { ...config, activeAreaId: areaId };
    return {
      ...state,
      config: newConfig
    };
  })
  .case(enableTagMode, state => ({
    ...state,
    tagMode: true,
    areas: [],
    config: {}
  }))
  .case(disableTagMode, state => ({
    ...state,
    tagMode: false,
    areas: [],
    config: {}
  }))
  .case(appendTagArea, (state, area) => {
    const areas: TagArea[] = state.areas;

    const newAreas = areas.filter(item => area.areaId !== item.areaId);
    newAreas.push(area);

    return {
      ...state,
      areas: newAreas
    };
  })
  .case(setTagConfig, (state, params) => {
    return {
      ...state,
      config: params
    };
  })
  .case(saveTagArea.async.done, (state, { result }) => {
    const areas = state.areas;
    const newAreas = areas.filter(
      area => state.config.activeAreaId !== area.areaId
    );

    newAreas.push({ ...result, areaId: state.config.activeAreaId });

    return {
      ...state,
      areas: newAreas,
      config: {
        ...state.config,
        activeAreaId: null
      }
    };
  })
  .case(editTagAreaText, (state, { areaId, value }) => {
    const areas = state.areas;
    const editedArea = areas.filter(area => areaId === area.areaId)[0];

    if (!editedArea) {
      return state;
    }

    editedArea.value = value;

    const filteredAreas = areas.filter(area => areaId !== area.areaId);
    filteredAreas.push(editedArea);

    return {
      ...state,
      areas: filteredAreas
    };
  });



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/Tag/reducer.ts